module.exports = __webpack_public_path__ + "img/google_pay_logo.493bde41.png";